module.exports = __webpack_public_path__ + "img/img42.c33def68.svg";